import React, { useEffect } from 'react';
import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import BaseModal from '@components/ui/BaseModal';
import useFeaturesAllowed from '@hooks/useFeaturesAllowed';
import UpdateYourPlan from '@components/ui/UpdateYourPlan';
import Form from './Form';
import { DrawerPropsInterface } from './DrawerTypes';
import * as Styled from './DrawerStyles';

function Drawer({
  actionsDrawerInnerRef,
  baseDrawerRef,
  contentDrawerRef,
  isMobile,
  isShow,
  onClose,
  onSuccess,
}: DrawerPropsInterface) {
  const { amplitudeEvent } = useAmplitude();
  const {
    isFeatureAllowed,
    featureHasLoaded,
    requestUpdateFeaturesAllowed,
    isloadingFeatureAllowed,
  } = useFeaturesAllowed();

  const featureCreateProposalName = 'create-proposal';

  function handleRenderForm() {
    if (
      isFeatureAllowed(featureCreateProposalName) &&
      !isloadingFeatureAllowed(featureCreateProposalName)
    ) {
      return (
        <Form
          actionsInnerRef={actionsDrawerInnerRef}
          onCancel={() => onClose()}
          onSuccess={() => onSuccess()}
        />
      );
    }

    return (
      <UpdateYourPlan
        title="Atualize seu plano e
crie viagens ilimitadas"
      >
        <FuelTypography
          tag="p"
          size="body-md"
          weight="medium"
          color="neutral-default"
          spacingTop={24}
        >
          Atualize para o <Styled.Strong>Plano completo</Styled.Strong> ou
          <Styled.Strong> Plano avançado</Styled.Strong> para ter acesso a
          criação de viagens.
        </FuelTypography>
      </UpdateYourPlan>
    );
  }

  useEffect(() => {
    if (isShow && !featureHasLoaded(featureCreateProposalName)) {
      requestUpdateFeaturesAllowed(featureCreateProposalName);
    }
  }, [isShow]);

  return (
    <BaseModal
      isOpen={isShow}
      onClose={() => onClose()}
      innerRef={baseDrawerRef}
      vAlignment="top"
      hAlignment="right"
      hOverlay
    >
      <Styled.WrapperContentModal ref={contentDrawerRef}>
        <FuelFlex defaultProps={{ alignItems: 'center', gap: 'km6' }}>
          <FuelButton
            variant="secondary"
            size="medium"
            leadingIcon="close"
            onlyIcon
            onClick={() => {
              amplitudeEvent('journey_create_button_clicked', {
                source: 'button-x',
              });
              onClose();
            }}
            data-testid="button-close"
          />
          <div>
            <FuelTypography
              size={isMobile ? 'heading-sm' : 'heading-md'}
              weight="bold"
              color="neutral-strong"
              spacingTop={0}
              spacingBottom={0}
              spacingRight={8}
              tag="h3"
            >
              Iniciar monitoramento
            </FuelTypography>
          </div>
        </FuelFlex>
        {handleRenderForm()}
      </Styled.WrapperContentModal>
    </BaseModal>
  );
}

export default Drawer;
